import { Fuel } from "../models/Fuel";
import { PaymentMethod } from "../models/PaymentMethod";
import { ProfileClass } from "../models/ProfileClass";

export interface ApiClient {
  getTariffs(
    body: GetTariffsRequest,
    fetchOptions?: RequestInit
  ): Promise<Response>;
}

export interface GetTariffsRequest {
  postcode?: string;
  profileClass?: ProfileClass;
  paymentMethod?: PaymentMethod;
  fuel?: Fuel;
  forSale?: boolean;
  region?: string;
}

export function createApiClient({
  fetchClient,
  apiHost,
}: {
  fetchClient: WindowOrWorkerGlobalScope["fetch"];
  apiHost: string;
}): ApiClient {
  function camelToSnakeCase(str: string): string {
    return str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
  }

  function urlFor(endpoint: string, query?: Record<string, string>): string {
    const url = new URL(apiHost);
    url.pathname = endpoint;
    url.search = new URLSearchParams(query).toString();
    return url.toString();
  }

  return {
    getTariffs(
      request: GetTariffsRequest,
      fetchOptions: RequestInit = {}
    ): Promise<Response> {
      const query = Object.entries(request).map(([key, value]) => [
        camelToSnakeCase(key.toString()),
        key !== "region" ? value.toString().toLowerCase() : value.toString(),
      ]);

      return fetchClient(
        urlFor("tariffs", Object.fromEntries(query)),
        fetchOptions
      );
    },
  };
}
